export default __webpack_public_path__ + "static/media/logo.d7e50040.png";